import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchRewardsInfo, signupForRewards } from 'actions/account/rewards';
import { PageLoader } from 'components/Loader';
import { fetchLandingPageInfo } from 'actions/landing/landingPageInfo';
import { checkCustomerAuthentication } from 'actions/authentication';
import { AriaLiveTee } from 'components/common/AriaLive';
import VipOptIn from 'components/account/VipDashboard/VipOptIn';
import HeaderBar from 'components/account/VipDashboard/HeaderBar';
import PerksAndPoints from 'components/account/VipDashboard/PerksAndPoints';
import Slots from 'components/account/VipDashboard/Slots';
import SiteAwareMetadata from 'components/SiteAwareMetadata';
import Breadcrumb from 'components/account/Breadcrumb';
import AccountHeader from 'containers/account/AccountHeader';
import BackNav from 'components/account/BackNav';
import { stripSpecialCharsDashReplace } from 'helpers';
import css from 'styles/containers/account/vipDashboard.scss';
import { trackLegacyEvent } from 'helpers/analytics';

const items = [{ name: 'VIP' }];

export class VipDashboard extends Component {
  static defaultProps = {
    trackLegacyEvent
  };

  static contextTypes = {
    testId: PropTypes.func,
    marketplace: PropTypes.object
  };

  componentDidMount() {
    const { checkCustomerAuthentication } = this.props;
    const returnTo = '/rewards/dashboard';
    checkCustomerAuthentication(returnTo, () => this.fetchData(returnTo));
  }

  handleSignupClick = e => {
    e.preventDefault();
    const { signupForRewards } = this.props;
    signupForRewards();
  };

  onLandingComponentClick = e => {
    // Send Analytics component click data via trackLegacyEvent(). The format of this data will change in the future
    // but for now we're sending the landing page parameters the way analytics/siteops wants them, mostly
    // the same as how they're currently formatted in legacy
    const { landingPage, trackLegacyEvent } = this.props;
    const { currentTarget } = e;
    const action = `RewardsDashboard-${landingPage.pageInfo.subPageType}-${landingPage.pageName}`; // set as the action param for trackEvent
    const label = stripSpecialCharsDashReplace(currentTarget.getAttribute('data-eventlabel')); // set as the label param for trackEvent
    const value = stripSpecialCharsDashReplace(currentTarget.getAttribute('data-eventvalue')); // set as the value param for trackEvent

    e.stopPropagation();
    trackLegacyEvent(action, label, value);
  }

  fetchData(returnTo) {
    const {
      rewards: { rewardsInfo },
      fetchLandingPageInfo,
      fetchRewardsInfo,
      landingPage: { pageInfo }
    } = this.props;

    const { marketplace: { account: { vipDashboardPageName } } } = this.context;

    if (!rewardsInfo) {
      fetchRewardsInfo({ returnTo });
    }

    if (!pageInfo) {
      fetchLandingPageInfo(vipDashboardPageName);
    }
  }

  render() {
    const { testId } = this.context;

    const {
      landingPage: { isLoaded, pageInfo, pageInfo: { slotData } = {}, slotOrder = [] },
      rewards: { isLoading, rewardsInfo }
    } = this.props;

    if (isLoading || !rewardsInfo || !isLoaded || !pageInfo) {
      return <PageLoader centered={true}/>;
    }

    const { canEnroll, consented, prime, spendPoints, spendPointsDollarValue } = rewardsInfo;

    return (
      <SiteAwareMetadata>
        <div className={css.vipDashboard} data-test-id={testId('vipDashboard')}>
          <BackNav to="/account">My Account</BackNav>
          <Breadcrumb items={items}/>
          <AccountHeader
            title="VIP Dashboard"
            showCustomerEmail={false}
            showFirstName={false}
            prime={false} />

          {
            !consented && (canEnroll
              ? (
                <div className={css.optInGrid}>
                  <div>
                    <VipOptIn onSignUp={this.handleSignupClick}/>
                  </div>
                  <div>
                    <PerksAndPoints isPerksOnly={true} />
                  </div>
                </div>
              )
              : <p className={css.rewardsIneligible} data-test-id={testId('rewardsIneligibleMessage')}><AriaLiveTee>We're sorry, but your account is not eligible for Zappos VIP.</AriaLiveTee></p>)
          }
          { consented && (
            <>
              <HeaderBar
                isPrime={prime}
                spendPoints={spendPoints}
                spendPointsDollarValue={spendPointsDollarValue} />
              <div className={css.grid}>
                <div>
                  <Slots
                    onLandingComponentClick={this.onLandingComponentClick}
                    slotData={slotData}
                    slotGroup="vipDashboardPromoTiles"
                    slotOrder={slotOrder}
                    startSlot={21}
                    endSlot={30} />
                </div>
                <div>
                  <h2>Earn Extra Points Shopping These Selected Brands</h2>
                  <Slots
                    onLandingComponentClick={this.onLandingComponentClick}
                    slotData={slotData}
                    slotGroup="vipDashboardFeatureBrands"
                    slotOrder={slotOrder}
                    startSlot={0}
                    endSlot={20} />
                  <PerksAndPoints />
                </div>
              </div>
            </>
          )}
        </div>
      </SiteAwareMetadata>
    );
  }
}

const mapStateToProps = ({ landingPage, rewards }) => ({
  rewards,
  landingPage
});

export default connect(mapStateToProps, {
  checkCustomerAuthentication,
  fetchLandingPageInfo,
  fetchRewardsInfo,
  signupForRewards
})(VipDashboard);
